import React from 'react';
import FieldMapList from '../components/fieldmap/FieldMapList';
import { Box } from '@mui/material';

const Component = ({ classes }) => {
  return (
    <Box sx={{
      width: '100%',
      display: 'flex',
      flex: 1,
    }}>
      <FieldMapList />
    </Box>
  );
};

export default Component;
